/* ------------------------------------------------------------------------------
@name: Components Index
@description: Indexing all components
--------------------------------------------------------------------------------- */

import WindowScroll from "./WindowScroll";
import Header from "./Header";
import HeroBanner from "./HeroBanner";
import Tabs from "./Tabs";
import CardProduct from "./CardProduct";
import WindowResize from "./WindowResize";
import Footer from "./Footer";
import Validation from "./Validation";
import HeaderSearch from "./HeaderSearch";
import Contact from "./Contact";
import Category from "./Category";
import SortingCategory from "./SortingCategory";
import TitlePage from "./TitlePage";
import ProductDetail from "./ProductDetail";
import Sale from "./Sale";
import Cart from "./Cart";

export {
  WindowScroll,
  Header,
  HeroBanner,
  Tabs,
  CardProduct,
  WindowResize,
  Footer,
  Validation,
  HeaderSearch,
  Contact,
  Category,
  SortingCategory,
  TitlePage,
  ProductDetail,
  Sale,
  Cart
};
